<script>
import playground from "../../../mixins/playground/playground";
import Response from "./ResultadoApi.vue";
import numeroProcesso from "../../../mixins/playground/numeroProcesso";

export default {
  name: "StatusAtualizacaoProcessoResumoIA",
  mixins:[playground, numeroProcesso],
  components: { Response },
  computed: {
    colunas() {
      return [
        { key: "numeroCnj", label: "Número CNJ", isVisible: false },
        { key: "status", label: "Status", isVisible: true },
        { key: "criadoEm", label: "Data de criação", isVisible: true },
        { key: "concluidoEm", label: "Data de conclusão", isVisible: true },
      ];
    }
  },
}
</script>

<template>
  <div>
    <form id="form-playground-status-atualizacao-processo-resumo" class="form-playground" @submit.prevent="consultar">
      <div class="space-y-2">
        <label for="numero_cnj" class="font-medium text-sm">Número CNJ</label>
        <input
          id="numero_cnj"
          name="numero_cnj"
          v-model="numero"
          class="input is-large px-2 rounded-md block"
          type="text"
          v-mask="'#######-##.####.#.##.####'"
          placeholder="0000000-00.0000.0.00.0000"
          autofocus="autofocus"
        />
      </div>
    </form>

    <div class="custo-small">
      <slot name="custo"></slot>
    </div>

    <Btn
      class="btn playground-button consultar-button"
      type="button"
      :loading="$wait.is(`fetching_${this.identificador}`)"
      :disabled="$wait.is(`fetching_${this.identificador}`) || inputInvalido"
      @click="consultar"
    >
      <p class="m-0 font-semibold">Consultar</p>
    </Btn>

    <Response
      v-if="response"
      :responseApi="response"
      :identificador="identificador"
      :key="identificador"
      :logIds="logIds"
      :lista-formatada="itens"
      :colunas="colunas"
      :tipos-download="['json']"
    >
    </Response>
  </div>
</template>

<style scoped lang="stylus" src="./playground.styl">

</style>
